import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormServices } from 'src/app/services/form-services.service';
import { HttpService } from 'src/app/services/http.service';
import { LoginService } from 'src/app/services/login.service';
import { StorageService } from 'src/app/services/storage.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {
  private _domainId = environment.domainId;
  public fieldForms: any[];
  public user: any;
  public uploading = false;

  constructor(
    private formSv: FormServices,
    private loginSv: LoginService,
    private httpSv: HttpService,
    private storageSv: StorageService,
    private uiSv: UiServices,
    private trSv: TranslateService
  ) {}

  async ngOnInit() {
    try{
      const typeForm = this.loginSv.user.rolId === 7 ? 'profileWSale' : 'profile'
      let form = await this.formSv.getForm(typeForm, this._domainId);;
      this.loginSv.user.media = [{users: this.loginSv.user.file}];
      this.user = this.loginSv.user;
      this.fieldForms = form;
      
    }catch(err){
      console.error(err);
      
    }
  }

  async saveProfile(profile: FormData){
    try{
      this.uploading = !this.uploading; 
      this.httpSv.loadingIndicatorSrc.next(this.uploading);
      const res: any = await this.httpSv.itemAction(profile, 'auth', 'update');
      const user = {
        token: this.loginSv.token,
        user: res.user
      }
      await this.storageSv.set('userInfo', user);
      this.uploading = !this.uploading; 
      this.httpSv.loadingIndicatorSrc.next(this.uploading);
      const tr = this.trSv.instant('GUARDADO_CON_EXITO');
      await this.uiSv.showToast(tr);
    }catch(err){
      console.error(err);
    }
  }

  deleteAccount(){
    this.loginSv.deleteAccount();
  }

}
